import {forwardRef} from "react";
import BarcodeLabel from "../BarcodeLabel";

const ComponentToPrintBarcodeInEditSection = forwardRef((props, refToPrintBarcode) => {
    const {submitResponse} = props;

    return (
        <div ref={refToPrintBarcode}>
            <BarcodeLabel
                barcodeCount={submitResponse !== undefined ? submitResponse.barcodeCount : 1}
                barcodeCountUserInput={submitResponse !== undefined ? submitResponse.barcodeCountUserInput : 1}
                barcodeLength={submitResponse !== undefined ? submitResponse.barcodeLength : 33}
                barcodeWidth={submitResponse !== undefined ? submitResponse.barcodeWidth : 50}
                paperWidth={submitResponse !== undefined ? submitResponse.paperWidth : 55}
                productCode={submitResponse !== undefined ? submitResponse.productCode : "1000"}
                productColor={submitResponse !== undefined ? submitResponse.productColor : "رنگ"}
                productName={submitResponse !== undefined ? submitResponse.productName : "نام محصول"}
                productPrice={submitResponse !== undefined ? submitResponse.productPrice : "قیمت"}
                productSize={submitResponse !== undefined ? submitResponse.productSize : "سایز"}
                productFont={submitResponse !== undefined ? submitResponse.productFont : "14"}
                priceFont={submitResponse !== undefined ? submitResponse.priceFont : "11"}
                displayProductCodeValue={submitResponse !== undefined ? submitResponse.displayProductCodeValue : true}
            />
        </div>
    )
});

export default ComponentToPrintBarcodeInEditSection;